// extracted by mini-css-extract-plugin
export var ArticlesContainer = "RecentArticles-module--ArticlesContainer--b8237";
export var RecentArticle = "RecentArticles-module--RecentArticle--f1eeb";
export var blogImg = "RecentArticles-module--blogImg--03d47";
export var dateContainer = "RecentArticles-module--dateContainer--2b1b5";
export var mainContainerFlex = "RecentArticles-module--mainContainerFlex--614c6";
export var textContainer = "RecentArticles-module--textContainer--b940d";
export var titleContainer = "RecentArticles-module--titleContainer--37b02";